import { Heart, MessageCircle, Share2, Eye } from "lucide-react";

interface EngagementMetricsProps {
  likes: number;
  comments: number;
  shares: number;
  views: number;
}

function formatCount(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
}

export function EngagementMetrics({ likes, comments, shares, views }: EngagementMetricsProps) {
  const metrics = [
    { icon: Heart, value: likes, label: 'likes' },
    { icon: MessageCircle, value: comments, label: 'comments' },
    { icon: Share2, value: shares, label: 'shares' },
    { icon: Eye, value: views, label: 'views' },
  ].filter(m => m.value > 0);

  if (metrics.length === 0) return null;

  return (
    <div className="flex items-center gap-4 text-sm" style={{ color: 'rgba(27,27,27,0.62)' }}>
      {metrics.map(({ icon: Icon, value, label }) => (
        <span key={label} className="flex items-center gap-1">
          <Icon className="w-3.5 h-3.5" />
          {formatCount(value)}
        </span>
      ))}
    </div>
  );
}
